var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "back-to-home rounded d-none d-sm-block"
  }, [_c('a', {
    staticClass: "btn btn-icon btn-soft-primary",
    attrs: {
      "href": "index.html"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "home"
    }
  })], 1)]), _c('section', {
    staticClass: "bg-home d-flex align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-lg-6 col-md-7"
  }, [_c('div', {
    staticClass: "card login_page  border-0"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', [_vm._v("Bi želeli še sodelovati?")]), _c('b-btn', {
    attrs: {
      "size": "lg"
    },
    on: {
      "click": function click($event) {
        return _vm.resetQuiz();
      }
    }
  }, [_vm._v("Naloži dodatna vprašanja")])], 1)])])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-lg-6 col-md-5"
  }, [_c('div', {
    staticClass: "mr-lg-5"
  }, [_c('h3', [_c('span', {
    staticClass: "text-success"
  }, [_vm._v("Hvala!")]), _c('br'), _vm._v("Vprašalnik je zaključen. ")]), _c('img', {
    staticClass: "img-fluid d-block mx-auto",
    attrs: {
      "src": require("@/assets/images/illustrator/Asset189.svg"),
      "alt": ""
    }
  })])]);
}]

export { render, staticRenderFns }